<template>
  <div>
    <list-layout
      sourceType="os"
      :can-operate="canOperate"
      :column-default-selected="columnDefaultSelected"
      :columns-all="columnsAll"
      :default-selected="tableDefaultSelectData"
      :export-func="exportFunc"
      :get-table-data-func="getTableDataFunc"
      :group-tree-func="groupTreeFunc"
      :in-modal="inModal"
      :refresh="updateTableFlag"
      :search-type-options="[
        { label: '名称', value: 'name' },
        { label: 'IP 地址', value: 'monitor_address' },
        { label: '系统版本', value: 'version' },
        { label: '群组名称', value: 'group_id' }
      ]"
      :table-operation-width="tableOperationWidth"
      :tools-list="toolsList"
      @tableSelectData="getSelectData"
      :customer-params="params"
      :apiPermission="groupApiPermission"
      :can-drag-column-width="true"
    >
      <template #leftTool>
        <create-button v-permission="{action: 'base.os.create', effect: 'disabled'}" @click="$refs.inputDrawer.show()">
        </create-button>
      </template>
      <!-- 表格自定义列 -->
      <template #name="{ slotProps }">
        <a-tooltip placement="topLeft" :title="slotProps.text">
          <a
            @click="$refs.detailDrawer.show(slotProps.record.id)"
            v-if="link"
            style="
              max-width: 180px;
              display: block;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            "
          >
            {{ slotProps.text }}
          </a>
          <span v-else>{{ slotProps.text }}</span>
        </a-tooltip>
      </template>
      <template #groups="{ slotProps }">
        <a-tooltip v-if="slotProps.text && slotProps.text.length">
          <a-space slot="title" :size="8">
            <div v-for="item in slotProps.text" :key="item.id">{{item.name}}</div>
          </a-space>
          <a-tag v-for="item in slotProps.text" :key="item.id">{{ item.name }}</a-tag>
        </a-tooltip>
        <span v-else>-</span>
      </template>
      <template #osType="{ slotProps }">
        <a-tooltip v-if="slotProps.text" :title="$t(`os_type.${slotProps.text}`)">
          {{ $t(`os_type.${slotProps.text}`) }}
        </a-tooltip>
        <span v-else>-</span>
      </template>
      <template #cpu="{ slotProps }">
        {{ slotProps.text || slotProps.text === 0 ? `${slotProps.text} 核` : '-' }}
      </template>
      <template #memory="{ slotProps }">
        {{ slotProps.text || slotProps.text === 0 ? `${slotProps.text} GB` : '-' }}
      </template>
      <template #disk="{ slotProps }">
        {{ slotProps.text || slotProps.text === 0 ? `${slotProps.text} GB` : '-' }}
      </template>
      <template #statusTitle>
        <status-question-icon></status-question-icon>
      </template>
      <template #status="{ slotProps }">
        <source-status-tag :status="slotProps.text"></source-status-tag>
      </template>
      <template #location="{ slotProps }">
        <a-tooltip v-if="slotProps.text" :title="slotProps.text">{{ slotProps.text }}</a-tooltip>
        <span v-else>-</span>
      </template>
      <template #operation="{ slotProps }">
        <sync-button @click="sync(slotProps.record.id)"></sync-button>
        <edit-button
        v-permission="{action: 'base.os.update', effect: 'disabled'}"
          @click="$refs.inputDrawer.show(slotProps.record.id)"
        ></edit-button>
        <delete-button v-permission="{action: 'base.os.delete', effect: 'disabled'}" @confirm="confirm(slotProps.record.id)"></delete-button>
      </template>
    </list-layout>

    <os-drawer ref="detailDrawer"></os-drawer>
    <input-drawer ref="inputDrawer" @ok="confirm"></input-drawer>
  </div>
</template>

<script>
import {
  createOSGroup,
  deleteOS,
  deleteOSGroup,
  exportOS,
  getOSGroup,
  getOSGroupList,
  getOSList,
  syncOS,
  updateOSGroup
} from '@/api/os'
import ListLayout from '@/components/ListLayout'
import DeleteButton from '@/components/button/DeleteButton'
import EditButton from '@/components/button/EditButton'
import CreateButton from '@/components/button/CreateButton'
import SyncButton from '@/components/button/SyncButton'
import StatusQuestionIcon from '@/components/icon/StatusQuestionIcon'
import SourceStatusTag from '@/components/tag/SourceStatusTag'
import { sourceStatuses, osTypes } from '@/utils/const'
import { hasPermission } from '@/utils'

export default {
  name: 'OSTable',
  components: {
    DeleteButton,
    EditButton,
    CreateButton,
    InputDrawer: () => import('./modules/InputDrawer'),
    ListLayout,
    'os-drawer': () => import('@/components/drawer/OSDrawer/index.vue'),
    StatusQuestionIcon,
    SourceStatusTag,
    SyncButton
  },
  props: {
    defaultSelected: {
      type: Array
    },
    toolsList: {
      type: Array,
      default: () => []
    },
    tableOperationWidth: {
      type: Number,
      default: 240
    },
    link: {
      type: Boolean,
      default: true
    },
    refresh: {
      type: Boolean
    },
    canOperate: {
      type: Boolean,
      default: true
    },
    inModal: {
      type: Boolean,
      default: false
    },
    fetchParams: {
      type: Object
    }
  },
  data () {
    return {
      getTableDataFunc: getOSList,
      exportFunc: exportOS,
      columnsAll: [
        {
          dataIndex: 'name',
          title: '名称',
          fixed: 'left',
          width: 240,
          ellipsis: true,
          scopedSlots: {
            customRender: 'name'
          }
        },
        {
          dataIndex: 'groups',
          title: '所属群组',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'groups'
          }
        },
        {
          dataIndex: 'hostname',
          title: '英文名称',
          width: 200,
          ellipsis: true,
          scopedSlots: {
            customRender: 'hostname'
          }
        },
        {
          dataIndex: 'monitor_address',
          title: 'IP 地址',
          width: 160,
          scopedSlots: {
            customRender: 'monitorAddress'
          }
        },
        {
          dataIndex: 'os_type',
          title: '系统类型',
          width: 120,
          scopedSlots: {
            customRender: 'osType'
          },
          filteredValue: [],
          filters: osTypes.map(value => {
            return {
              text: this.$t(`os_type.${value}`),
              value
            }
          }),
          filterMultiple: false
        },
        {
          dataIndex: 'version',
          title: '版本',
          width: 120,
          ellipsis: true,
          scopedSlots: {
            customRender: 'version'
          }
        },
        {
          dataIndex: 'cpu',
          title: 'CPU',
          width: 100,
          align: 'center',
          scopedSlots: {
            customRender: 'cpu'
          }
        },
        {
          dataIndex: 'memory',
          title: '内存',
          align: 'center',
          width: 100,
          scopedSlots: {
            customRender: 'memory'
          }
        },
        {
          dataIndex: 'disk',
          title: '磁盘',
          width: 120,
          align: 'center',
          scopedSlots: {
            customRender: 'disk'
          }
        },
        {
          dataIndex: 'monitor_port',
          title: '监控端口',
          width: 100,
          scopedSlots: {
            customRender: 'monitorPort'
          }
        },
        {
          dataIndex: 'location',
          title: '位置',
          ellipsis: true,
          width: 160,
          scopedSlots: {
            customRender: 'location'
          }
        },
        {
          dataIndex: 'status',
          width: 100,
          slots: {
            title: 'statusTitle',
            name: '状态'
          },
          scopedSlots: {
            customRender: 'status'
          },
          filteredValue: [],
          filters: sourceStatuses.map(value => {
            return {
              text: this.$t(`source_status.${value}`),
              value
            }
          }),
          filterMultiple: false
        },
        {
          dataIndex: 'created_at',
          title: '创建时间',
          width: 200
        },
        {
          dataIndex: 'updated_at',
          title: '更新时间',
          width: 200
        }
      ],
      columnDefaultSelected: [
        'name',
        'groups',
        'os_type',
        'version',
        'monitor_address',
        'cpu',
        'memory',
        'disk',
        'status',
        'location'
      ],
      updateTableFlag: this.refresh,
      customerParams: this.$route.params,
      tableSelectData: [],
      tableDefaultSelectData: [],
      groupApiPermission: {
        create: 'base.os_group.create',
        edit: 'base.os_group.update',
        delete: 'base.os_group.delete'
      }
    }
  },
  computed: {
    params () {
      const obj = {}
      for (const key in this.customerParams) {
        if (Object.hasOwnProperty.call(this.customerParams, key)) {
          obj[key] = this.customerParams[key]
        }
      }
      for (const key in this.fetchParams) {
        if (Object.hasOwnProperty.call(this.fetchParams, key)) {
          obj[key] = this.fetchParams[key]
        }
      }
      this.columnsAll.forEach(column => {
        if (Object.hasOwnProperty.call(column, 'filteredValue')) {
          if (Object.hasOwnProperty.call(obj, column.dataIndex)) {
            column.filteredValue = [obj[column.dataIndex]]
          } else column.filteredValue = []
        }
      })
      return obj
    },
    groupTreeFunc () {
      if (hasPermission('base.os_group.view')) {
        return {
          createFunc: createOSGroup,
          deleteFunc: deleteOSGroup,
          getFunc: getOSGroup,
          getListFunc: getOSGroupList,
          updateFunc: updateOSGroup
        }
      } else return null
    }
  },
  mounted () {
    if (this.defaultSelected) this.tableDefaultSelectData = this.defaultSelected
  },
  methods: {
    getSelectData (data) {
      this.tableSelectData = data
      this.$emit('selectedData', data)
    },
    async confirm (id = '') {
      if (id) {
        await deleteOS(id).then(res => {
          this.$message.success(res.message)
        })
        this.tableSelectData.splice(
          this.tableSelectData.findIndex(item => item.key === id),
          1
        )
        this.tableDefaultSelectData = this.tableSelectData
        this.$emit('selectedData', this.tableSelectData)
      }
      this.updateTableFlag = !this.updateTableFlag
    },
    sync (id) {
      syncOS({ id }).then(res => {
        this.$message.success(res.message)
      })
    }
  },
  watch: {
    refresh (v) {
      this.updateTableFlag = v
    }
  }
}
</script>
